import React, { useState } from "react";

type InputProps = {
  value: string | number | undefined;
  label: string;
  placeholder: string;
  name: string;
  error?: string | undefined;
  touched?: boolean | number;
  isDisabled?: boolean;
  required?: boolean;
  onChange: (e: any) => void;
  showLabel?: boolean;
  setFieldTouched?: any;
  maxLength?: number;
  height?: string;
};

export default function TextArea({
  value,
  label,
  placeholder,
  name,
  error,
  touched,
  isDisabled,
  required,
  onChange,
  setFieldTouched,
  maxLength,
  height,
}: InputProps) {
  const showError = error && touched;
  const remainingCharacters = maxLength - (value?.toString().length || 0);

  const handleChange = (e) => {
    if (maxLength) {
      if (e.target.value.length <= maxLength) {
        onChange(e);
      }
    } else {
      onChange(e);
    }
  };

  return (
    <label className="block">
      <span className="text-sm text-black-secondary font-medium font-medium mb-2 flex">
        {label}
        {required && <p className="text-sm text-error-500 ml-1">*</p>}
      </span>
      <div className=" relative">
        <textarea
          className={`${showError ? "border-error-300" : "border-gray-300"} placeholder:text-gray-500 block bg-white w-full border border-gray-400 rounded-md py-2 pl-3 pr-3
         shadow-sm focus:ring-brand-300 focus:border-brand-300 focus:ring-0 focus:outline-none focus:ring-offset-2 focus:ring-offset-brand-50 
         sm:text-base disabled:bg-gray-50 disabled:border-gray-300 placeholder:text-base placeholder:font-normal 
          ${height ? height : ""}
          `}
          name={name}
          placeholder={placeholder}
          onBlur={(e) => {
            setFieldTouched ? setFieldTouched(name, false) : "";
          }}
          onFocus={(e) => {
            setFieldTouched ? setFieldTouched(name, true) : "";
          }}
          value={value}
          maxLength={maxLength}
          onChange={handleChange}
          disabled={isDisabled}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e?.stopPropagation();
            }
          }} //to cancel parent
        />
      </div>
      {maxLength && (
        <p className="text-sm font-normal text-gray-600 mt-2">
          {remainingCharacters} characters left
        </p>
      )}
      {showError && <p className="text-sm text-red-500">{error}</p>}
    </label>
  );
}
